// Generated prop information for BannerWidget
const propList = [
  "title",
  "description",
  "imageUrl",
  "imageAlt",
  "position",
  "variant",
  "size",
  "targetUrl",
  "buttonText",
  "showButton",
  "className",
  "trackingId",
  "aspectRatio",
  "onClick",
  "hideWidget"
];
export default propList;

// Detailed prop information with types
export const propInfo = [
  {
    "name": "title",
    "type": "string",
    "optional": false
  },
  {
    "name": "description",
    "type": "string",
    "optional": true
  },
  {
    "name": "imageUrl",
    "type": "string",
    "optional": false
  },
  {
    "name": "imageAlt",
    "type": "string",
    "optional": false
  },
  {
    "name": "position",
    "type": "string",
    "optional": true
  },
  {
    "name": "variant",
    "type": "string",
    "optional": true
  },
  {
    "name": "size",
    "type": "string",
    "optional": true
  },
  {
    "name": "targetUrl",
    "type": "string",
    "optional": false
  },
  {
    "name": "buttonText",
    "type": "string",
    "optional": true
  },
  {
    "name": "showButton",
    "type": "boolean",
    "optional": true
  },
  {
    "name": "className",
    "type": "string",
    "optional": true
  },
  {
    "name": "trackingId",
    "type": "string",
    "optional": true
  },
  {
    "name": "aspectRatio",
    "type": "number",
    "optional": true
  },
  {
    "name": "onClick",
    "type": "function",
    "optional": true
  },
  {
    "name": "hideWidget",
    "type": "boolean",
    "optional": true
  }
];
